import { CameraManager } from 'ohzi-core';
import { Time } from 'ohzi-core';
import { EasingFunctions } from 'ohzi-core';
import { Math as TMath } from 'three';
import HomeView from '../../html_components/HomeView';
import HTMLManager from '../../html_components/HTMLManager';
import Animator from '../animator/Animator';

export default class Wall
{
  constructor(obj, type, initial_x_pos, row_index)
  {
    this.id = undefined;
    this.obj = obj;
    this.solid = this.obj.children[0];
    this.text = undefined;
    this.row_index = row_index;
    this.sibling = undefined;

    this.type = type;
    // this.initial_x_pos = initial_x_pos;
    // this.initial_hover_x_pos = 0;

    this.initial_text_x_pos = undefined;

    // this.last_hover_x_pos = this.initial_x_pos;
    this.is_hover = false;
    this.hover_t = 0;

    this.start_x_camera = initial_x_pos;
    // this.end_x_camera = 0;

    this.start_x_hover = initial_x_pos;
    this.end_x_hover = 0;

    this.initial_opacity = 0.8;

    this.opacity_animator = new Animator(
      this.initial_opacity,
      1,
      1,
      EasingFunctions.ease_in_out_quint,
      this.set_solid_opacity.bind(this)
    );

    this.gradient_animator = new Animator(
      0,
      1,
      1,
      EasingFunctions.ease_in_out_cubic,
      this.set_solid_gradient.bind(this)
    );

    this.is_opaque = false;
    this.is_pointer_cursor = false;
    this.video_playing = false;

    this.dir = this.type === 'left' ? -1 : 1;

    this.is_opened = false;
  }

  get_hover_position()
  {
    return TMath.lerp(this.start_x_hover, this.end_x_hover, this.hover_t);
  }

  get_camera_position(offset)
  {
    return this.__calculate_x_pos(this.start_x_camera, offset);
  }

  update()
  {
    // IF wall with lab
    if (this.sibling && this.text)
    {
      this.opacity_animator.update();
      this.gradient_animator.update();

      if (!this.is_opened)
      {
        this.hover_t -= Time.delta_time;
        this.hover_t = TMath.clamp(this.hover_t, 0, 1);
      }

      let hover_x = this.get_hover_position();
      let camera_x = this.get_camera_position();

      if (Math.abs(camera_x) < 34.5)
      {
        this.play_video();
      }
      else
      {
        if (!this.is_hover)
        {
          this.pause_video();
        }
      }

      let final_x = TMath.lerp(camera_x, hover_x, EasingFunctions.ease_in_out_cubic(this.hover_t));

      this.set_position(final_x);
      this.set_sibling_position(final_x + 70 * this.dir);

      // this.sibling.set_sibling_opacity((1 - this.hover_t) * 5);

      let text_position = this.__calculate_x_pos(this.initial_text_x_pos, this.text_offset);

      this.set_text_position(text_position, EasingFunctions.ease_in_out_cubic(this.hover_t));
    }

    // Set opacity depending on the distance
    let t = (Math.abs(CameraManager.current.position.z - this.obj.position.z)) / 150;
    t = 1 - TMath.clamp(t, 0, 1);
    t = EasingFunctions.ease_in_out_cubic(t);

    this.set_opacity(t);
  }

  set_position(offset)
  {
    console.error('abstract method');
  }

  set_sibling_position(offset)
  {
    console.error('abstract method');
  }

  set_text_position(offset)
  {
    console.error('abstract method');
  }

  set_opacity(opacity)
  {
    // Glass
    this.obj.children[0].material.opacity = opacity;

    if (this.text)
    {
      this.text.opacity = opacity;
    }
  }

  set_sibling_opacity(opacity)
  {
    // TODO: this is not working
    this.obj.getObjectByName('glass').material.opacity = opacity;
    this.obj.getObjectByName('light_left').material.opacity = opacity;
    this.obj.getObjectByName('light_up').material.opacity = opacity;
  }

  set_solid_gradient(gradient)
  {
    this.solid.material.set_gradient(gradient);
  }

  set_solid_opacity(opacity)
  {
    this.solid.material.opacity = opacity;
  }

  set_id(id)
  {
    this.id = id;
  }

  set_sibling(sibling)
  {
    this.sibling = sibling;
  }

  set_text(text)
  {
    console.error('abstract method');
  }

  on_hover_enter()
  {
    if (!this.is_hover)
    {
      this.is_hover = true;

      this.make_opaque();
      this.play_video();
      // this.set_pointer_cursor();
      // this.show_info();
    }
  }

  on_hover_leave()
  {
    if (this.is_hover)
    {
      this.is_hover = false;

      // this.set_initial_cursor();

      if (!this.is_opened)
      {
        this.make_translucent();
        this.pause_video();
      }
    }
  }

  show_info()
  {
    this.gradient_animator.animate();

    HomeView.show_lab_info(this);
  }

  hide_info()
  {
    this.gradient_animator.animate();

    HomeView.hide_lab_info(this);
  }

  play_video()
  {
    if (!this.video_playing)
    {
      this.video.play();
      this.video_playing = true;
    }
  }

  pause_video()
  {
    if (this.video_playing)
    {
      this.video.pause();
      this.video_playing = false;
    }
  }

  set_pointer_cursor()
  {
    if (!this.is_pointer_cursor)
    {
      HTMLManager.set_cursor('pointer');
      this.is_pointer_cursor = true;
    }
  }

  set_initial_cursor()
  {
    if (!this.is_hover && this.is_pointer_cursor)
    {
      HTMLManager.set_cursor('initial');
      this.is_pointer_cursor = false;
    }
  }

  make_opaque()
  {
    if (!this.is_opaque)
    {
      this.opacity_animator.from = this.solid.material.uniforms._Opacity.value;
      this.opacity_animator.to = 1;
      this.opacity_animator.animate();

      this.is_opaque = true;
    }
  }

  make_translucent()
  {
    if (this.is_opaque)
    {
      this.opacity_animator.from = this.solid.material.uniforms._Opacity.value;
      this.opacity_animator.to = this.initial_opacity;
      this.opacity_animator.animate();
      this.is_opaque = false;
    }
  }

  // make_invisible()
  // {
  //   if (!this.is_hover && !this.opacity_animator.is_animating())
  //   {
  //     this.opacity_animator.from = his.solid.material.uniforms._Opacity.value;
  //     this.opacity_animator.to = 0;
  //     this.opacity_animator.animate();
  //   }
  // }

  __calculate_x_pos(initial_x_pos, offset)
  {
    let t = (Math.abs(CameraManager.current.position.z - this.obj.position.z + 25)) / 20;
    t = 1 - TMath.clamp(t, 0, 1);
    t = EasingFunctions.ease_in_out_quint(t);

    let dir = this.type === 'left' ? 1 : -1;
    let x = t * (offset * -1) * dir + initial_x_pos;

    return x;
  }
}
